import { render, staticRenderFns } from "./newdetail.vue?vue&type=template&id=0024cf0e&scoped=true"
import script from "./newdetail.vue?vue&type=script&lang=js"
export * from "./newdetail.vue?vue&type=script&lang=js"
import style0 from "./newdetail.vue?vue&type=style&index=0&id=0024cf0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0024cf0e",
  null
  
)

export default component.exports